//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

export const LibraryTrackingIds = {
  SIDEBAR_FILTERS: 'media-library_sidebar-filters',
  OPEN_DRAWER_FROM_NAV: 'media-library_open-drawer-from-nav',
  SAVE_AS_COLLECTION: 'media-library_save-as-collection',
  TEAM_MEDIA: 'media-library_sidebar_team-media',
  MY_MEDIA: 'media-library_sidebar_my-media',
  ALL_MEDIA: 'media-library_sidebar_all-media',
  SIDEBAR_TRACKED_SOURCES: 'media-library_sidebar_tracked-sources',
  SIDEBAR_TRACKED_USERS: 'media-library_sidebar_tracked-users',
  SIDEBAR_TRACKED_HASHTAGS: 'media-library_sidebar_tracked-hashtags',
  SIDEBAR_MENTIONED_AND_TAGGED: 'media-library_sidebar_mentioned-tagged',
  SIDEBAR_COLLECTION: 'media-library_sidebar_collection',

  LABEL_MANAGEMENT_ENTRY_POINT: 'media-library_label_management_entry_point',
  LABEL_MANAGEMENT_DELETE_LABEL: 'media-library_label_management_delete_label',
  LABEL_MANAGEMENT_UPDATE_LABEL: 'media-library_label_management_update_label',
  LABEL_MANAGEMENT_DELETE_CONFIRMATION:
    'media-library_label_management_delete_confirmation',
  LABEL_MANAGEMENT_UPDATE_CONFIRMATION:
    'media-library_label_management_update_confirmation',
} as const;
